export enum DevicesActionType {
  GET_DEVICES_LIST_REQUEST = 'GET_DEVICES_LIST_REQUEST',
  GET_DEVICES_LIST_FAIL = 'GET_DEVICES_LIST_FAIL',
  GET_DEVICES_LIST_SUCCESS = 'GET_DEVICES_LIST_SUCCESS',
  CREATE_DEVICE_REQUEST = 'CREATE_DEVICE_REQUEST',
  CREATE_DEVICE_SUCCESS = 'CREATE_DEVICE_SUCCESS',
  CREATE_DEVICE_FAIL = 'CREATE_DEVICE_FAIL',
  EDIT_DEVICE_FAIL = 'EDIT_DEVICE_FAIL',
  EDIT_DEVICE_SUCCESS = 'EDIT_DEVICE_SUCCESS',
  EDIT_DEVICE_REQUEST = 'EDIT_DEVICE_REQUEST',
  DELETE_DEVICE_REQUEST = 'DELETE_DEVICE_REQUEST',
  DELETE_DEVICE_SUCCESS = 'DELETE_DEVICE_SUCCESS',
  DELETE_DEVICE_FAIL = 'DELETE_DEVICE_FAIL'
}
